import { STATUS_TYPE } from '../../../enum';
export interface FindNotification {
  isRead?: boolean;
  isExport?: boolean;
  receiverUserId?: string;
  moduleType?: string;
  search?: string;
  limit?: number;
  skip?: number;
}

interface InitialState {
  data: any[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
